import { ApprovalRequestMessage, DeclinedApprovalRequestMessage } from '../../../types/ApprovalRequestMessage';
import { OfferModel } from '../model/OfferModel';

import { ApprovalRequestBasicContent } from './ApprovalRequestBasicContent';
import { DeclinedStatusBar } from './DeclinedStatusBar';

interface DeclinedStateProps {
    offer: OfferModel;
    approvalRequests: ApprovalRequestMessage[];
    declinedApprovalRequest: DeclinedApprovalRequestMessage;
    shouldDisplayBackButton?: boolean;
}

export const DeclinedState = ({
    offer,
    approvalRequests,
    declinedApprovalRequest,
    shouldDisplayBackButton,
}: DeclinedStateProps) => {
    return (
        <ApprovalRequestBasicContent
            approvalRequests={approvalRequests}
            offer={offer}
            shouldDisplayBackButton={shouldDisplayBackButton}
        >
            <DeclinedStatusBar approvalRequest={declinedApprovalRequest} />
        </ApprovalRequestBasicContent>
    );
};
